import { render } from "./commentsList.vue?vue&type=template&id=a2361926"
import script from "./commentsList.vue?vue&type=script&lang=js"
export * from "./commentsList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./commentsList.vue?vue&type=style&index=0&id=a2361926&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__